import type { KidProfile } from "./types";

interface Props {
  kid: Pick<KidProfile, "totalSessions" | "attendedSessions" | "avgBattingScore" | "avgBowlingScore" | "avgFieldingScore">;
}

function compositeScore(
  batting: number | null,
  bowling: number | null,
  fielding: number | null,
): number | null {
  const vals = [batting, bowling, fielding].filter((v): v is number => v !== null);
  if (vals.length === 0) return null;
  return vals.reduce((a, b) => a + b, 0) / vals.length;
}

export function KidStatBadges({ kid }: Props) {
  const attendancePct =
    kid.totalSessions > 0
      ? Math.round((kid.attendedSessions / kid.totalSessions) * 100)
      : 0;

  const score = compositeScore(
    kid.avgBattingScore,
    kid.avgBowlingScore,
    kid.avgFieldingScore,
  );

  const stats = [
    { label: "Sessions", value: `${kid.attendedSessions}/${kid.totalSessions}` },
    { label: "Attendance", value: `${attendancePct}%` },
    { label: "Score", value: score !== null ? `${score.toFixed(1)} / 5` : "—" },
  ];

  return (
    <div
      className="grid grid-cols-3 gap-3"
      data-testid="kid-stat-badges"
    >
      {stats.map(({ label, value }) => (
        <div
          key={label}
          className="bg-white border border-gray-100 rounded-lg px-3 py-3 text-center shadow-sm"
        >
          <p className="text-xs text-gray-500 mb-1">{label}</p>
          <p className="text-base md:text-lg font-bold text-gray-900">{value}</p>
        </div>
      ))}
    </div>
  );
}
